import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';

import PagosTittle from './components/PagosTittle';
import PagosFiltros from './components/PagosFiltros';
import PagosAlertas from './components/PagosAlertas';
import PagosReferenciasDuplicadas from './components/PagosReferenciasDuplicadas';
import PagosLista from './components/PagosLista';
import ModalConciliarPago from './modals/ModalConciliarPago';

const PagosPage = () => {
    const { token, idCatTipoUsuario } = useToken();
    const { showErrorToast } = useToast();
    const navigate = useNavigate();

    // Estados del modal de conciliación
    const [showModalConciliar, setShowModalConciliar] = useState(false);
    const [ID_Pago, setID_Pago] = useState(0);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    // Estados de filtros
    const initialDate = sessionStorage.getItem("selectMes") == null ? new Date() : new Date(sessionStorage.getItem("selectMes"));
    const [dateQuarter, setDateQuarter] = useState(initialDate);
    const [idCatCuentaBancaria, setIdCatCuentaBancaria] = useState(sessionStorage.getItem("ctaBancariaConciliacion") || '');
    const [idCatMedioPago, setIdCatMedioPago] = useState(sessionStorage.getItem("idMedioPago") || '');
    const [idVendedor, setIDVendedor] = useState(sessionStorage.getItem("selectIDUsuario") || '');
    const [filterValidados, setFilterValidados] = useState("-1");
    const [filterStatus, setFilterStatus] = useState("-1");

    const filters = {
        month: (dateQuarter.getMonth() + 1).toString(),
        year: dateQuarter.getFullYear().toString(),
        idCatCuentaBancaria,
        idCatMedioPago,
        idVendedor,
        filterValidados,
        filterStatus
    };

    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
            return;
        }
        checkPermisos();
    }, []);

    const checkPermisos = async () => {
        const response = await fetch("/api/Administradores/checkPermisos", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response && response.ok) {
            const responseType = await response.json();
            if (responseType.iResponseType !== 1) {
                navigate("/");
            }
        } else {
            navigate("/");
        }
    };

    return (
        <>
            <PagosTittle filters={filters} />
            
            <PagosAlertas filters={filters} />

            <PagosReferenciasDuplicadas
                filters={filters}
                setID_Pago={setID_Pago}
                setShowModalConciliar={setShowModalConciliar}
                refreshTrigger={refreshTrigger}
            />

            <PagosFiltros
                dateQuarter={dateQuarter}
                setDateQuarter={setDateQuarter}
                idVendedor={idVendedor}
                setIDVendedor={setIDVendedor}
                idCatCuentaBancaria={idCatCuentaBancaria}
                setIdCatCuentaBancaria={setIdCatCuentaBancaria}
                idCatMedioPago={idCatMedioPago}
                setIdCatMedioPago={setIdCatMedioPago}
                filterValidados={filterValidados}
                setFilterValidados={setFilterValidados}
                filterStatus={filterStatus}
                setFilterStatus={setFilterStatus}
            />

            <PagosLista
                filters={filters}
                setID_Pago={setID_Pago}
                setShowModalConciliar={setShowModalConciliar}
            />

            {showModalConciliar &&
                <ModalConciliarPago
                    showModalConciliar={showModalConciliar}
                    setShowModalConciliar={setShowModalConciliar}
                    idPago={ID_Pago}
                    onPagoActualizado={() => setRefreshTrigger(prev => prev + 1)}
                />
            }
        </>
    );
};

export default PagosPage;
